export function getImgSrcSet(densities: number[], getSrc: (density: number) => string): string {
  return densities.reduce((acc: string, density: number) => {
    const src = getSrc(density);

    if (acc) {
      return acc + `, ${src} ${density}x`;
    }

    return `${src}`;
  }, '');
}
